import { useQuery } from "@tanstack/react-query";
import { fetch3 } from "../commonApis/commonApis";

const url = process.env.REACT_APP_BASE_URL;

export const useShipmentInventoryListData = (
  pageNo: number,
  limit: number,
  searchFor: string,
  warehouseId?: string
) => {
  return useQuery({
    queryKey: ["shipmentInventoryList", pageNo, limit, searchFor, warehouseId],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/inventory-movement?page=${pageNo}&limit=${limit}&searchFor=${encodeURIComponent(
          searchFor
        )}${warehouseId ? `&warehouseId=${warehouseId}` : ""}`,
        "get"
      );
      if (!res || !res.success) {
        throw new Error(res?.message || "Failed to fetch shipment inventory");
      }
      return res.data;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export const useFetchProductItemInventoryData = (
  page: number,
  limit: number,
  searchFor: string,
  isReserved?: boolean,
  warehouseId?: string
) => {
  const reservedParam =
    isReserved !== undefined ? `&is_reserved=${isReserved}` : "";
  const warehouseParam = warehouseId ? `&warehouseId=${warehouseId}` : "";
  return useQuery({
    queryKey: ["itemInventoriesData", page, limit, searchFor, isReserved, warehouseId],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/product-items-inventory?page=${page}&limit=${limit}&searchFor=${encodeURIComponent(
          searchFor
        )}&type=LM${reservedParam}${warehouseParam}`,
        "get"
      );
      if (!res || !res.success) {
        throw new Error(res?.message || "Failed to fetch item inventory");
      }
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};
